import React, { useMemo, useState } from 'react'

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { css } from 'styled-components';

function NewSurveyOnlineReport(props) {
    const { averageWeek, guestOpinion, calculatorWeek, dataChart, oldMonth, role, checkSend, branchID, sumTypeSurvey, isAreaAllMode, items, areaBranchTabs = [], areaName = "Area", mode = "report" } = props;
    const displayAreaName = isAreaAllMode && (areaName === "Select Area" || !areaName) ? "Viet Nam" : areaName;
    const [typeView, setTypeView] = useState("thisMonth");
    const [hiddenPaperSurvey, setHiddenPaperSurvey] = useState(false);
    const isNotHidden = branchID === 11 ? "" : " op-hidden"
    const demoVersion = true// branchID === 8 // false //true;
    const effectiveTypeView = mode === "statistic" ? "statistic" : typeView;
    const showBranchOnFeedback = isAreaAllMode;

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: 'Survey Chart',
            },
        },
    };

    const cssValue = {
        td: { fontSize: '1.2rem', textAlign:'center' },
    }

    function normalizeText(value) {
        if (value === undefined || value === null) return "";
        return String(value)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '')
            .toLowerCase();
    }

    function createCounter(labels) {
        const result = {};
        labels.forEach(label => {
            result[label] = 0;
        });
        return result;
    }

    function increaseCounter(counter, key, step = 1) {
        if (Object.prototype.hasOwnProperty.call(counter, key)) {
            counter[key] = Number(counter[key] || 0) + step;
        }
    }

    function getScoreFromQuestion5(question5, index) {
        const value = Number(question5?.[index]?.answer || 0);
        return value > 0 ? value : 0;
    }

    function resolveHowLongStaying(value) {
        if (value === 0 || value === "" || value === null || value === undefined) return "";
        const numberValue = Number(value);
        if (numberValue === 1) return "1 day";
        if (numberValue === 2) return "2-6 days";
        if (numberValue === 3) return "1-4 week";
        if (numberValue === 4) return "above 1 month";

        const text = normalizeText(value);
        if (text.includes('1day')) return "1 day";
        if (text.includes('2-6') || text.includes('2to6') || text.includes('2~6')) return "2-6 days";
        if (text.includes('1-4week') || text.includes('1to4week') || text.includes('1~4week')) return "1-4 week";
        if (text.includes('abovemonth') || text.includes('above1month') || text.includes('morethan1month')) return "above 1 month";
        return "";
    }

    function resolveGuestAge(value) {
        if (value === 0 || value === "" || value === null || value === undefined) return "";
        const numberValue = Number(value);
        if (numberValue === 1) return "secret";
        if (numberValue === 2) return "20's";
        if (numberValue === 3) return "30's";
        if (numberValue === 4) return "40's";
        if (numberValue === 5) return "50's";
        if (numberValue === 6) return "Above 50's";

        const text = normalizeText(value);
        if (text.includes('secret')) return "secret";
        if (text.includes('20')) return "20's";
        if (text.includes('30')) return "30's";
        if (text.includes('40')) return "40's";
        if (text.includes('50') && !text.includes('above')) return "50's";
        if (text.includes('above50') || text.includes('over50') || text.includes('morethan50')) return "Above 50's";
        return "";
    }

    function resolveHowManyTimes(value) {
        if (value === 0 || value === "" || value === null || value === undefined) return "";
        const numberValue = Number(value);
        if (numberValue === 1) return "First time";
        if (numberValue === 2) return "Second time";
        if (numberValue === 3) return "Third time";
        if (numberValue === 4) return "More than";

        const text = normalizeText(value);
        if (text.includes('first')) return "First time";
        if (text.includes('second')) return "Second time";
        if (text.includes('third')) return "Third time";
        if (text.includes('more')) return "More than";
        return "";
    }

    function resolveHowKnowAz(value) {
        if (value === 0 || value === "" || value === null || value === undefined) return "";
        const numberValue = Number(value);
        if (numberValue === 1) return "Company";
        if (numberValue === 2) return "Introduction";
        if (numberValue === 3) return "AZ WEB";
        if (numberValue === 4) return "OTA";
        if (numberValue === 5) return "Google";
        if (numberValue === 6) return "SNS";
        if (numberValue === 7) return "POSTE";
        if (numberValue === 8) return "Magazine";
        if (numberValue === 9) return "Other";

        const text = normalizeText(value);
        if (text.includes('company')) return "Company";
        if (text.includes('intro')) return "Introduction";
        if (text.includes('azweb') || text.includes('website')) return "AZ WEB";
        if (text.includes('ota')) return "OTA";
        if (text.includes('google')) return "Google";
        if (text.includes('sns') || text.includes('facebook') || text.includes('instagram')) return "SNS";
        if (text.includes('poste') || text.includes('poster')) return "POSTE";
        if (text.includes('magazine')) return "Magazine";
        if (text.includes('other')) return "Other";
        return "";
    }

    function resolveComeAgain(value) {
        if (value === 0 || value === "" || value === null || value === undefined) return "";
        const numberValue = Number(value);
        if (numberValue === 1) return "Come again";
        if (numberValue === 2) return "Don't know";
        if (numberValue === 3) return "Don't come again";

        const text = normalizeText(value);
        if (text.includes('comeagain')) return "Come again";
        if (text.includes('dontknow') || text.includes('notsure')) return "Don't know";
        if (text.includes('dontcome') || text.includes('notcome')) return "Don't come again";
        return "";
    }

    function splitImportantPoints(question6) {
        if (Array.isArray(question6)) return question6;
        if (typeof question6 === 'string') {
            if (question6.trim() === "") return [];
            return question6
                .split(/[\n,、;；/|]+/)
                .map(item => item.trim())
                .filter(Boolean);
        }
        if (question6 && typeof question6 === 'object') {
            return [question6.answer, question6.value, question6.name, question6.label, question6.text]
                .filter(item => item !== undefined && item !== null && item !== "");
        }
        return [];
    }

    function resolveImportantPoint(value) {
        const numberValue = Number(value);
        if (numberValue === 1) return 'Price';
        if (numberValue === 2) return 'Location';
        if (numberValue === 3) return 'Rotenburo';
        if (numberValue === 4) return 'Clealiness';
        if (numberValue === 5) return 'Breakfast';
        if (numberValue === 6) return 'Amenity';
        if (numberValue === 7) return 'Staff';
        if (numberValue === 8) return 'Japanese-chanel';
        if (numberValue === 9) return 'Internet';
        if (numberValue === 10) return 'Massage';
        if (numberValue === 11) return 'Japan-res';
        if (numberValue === 12) return 'Speak JP';
        if (numberValue === 13) return 'Other';

        const text = normalizeText(value);
        if (text.includes('price') || text.includes('pricevalue') || text.includes('roomprice') || text.includes('kyaria')) return 'Price';
        if (text.includes('location') || text.includes('access') || text.includes('eki') || text.includes('ekimae')) return 'Location';
        if (text.includes('roten') || text.includes('onsen') || text.includes('rotenburo') || text.includes('露天') || text.includes('風呂')) return 'Rotenburo';
        if (text.includes('clean') || text.includes('cleanliness') || text.includes('cleaning') || text.includes('清潔') || text.includes('きれい') || text.includes('綺麗')) return 'Clealiness';
        if (text.includes('breakfast') || text.includes('bf') || text.includes('朝食')) return 'Breakfast';
        if (text.includes('amenity') || text.includes('facility') || text.includes('設備')) return 'Amenity';
        if (text.includes('staff') || text.includes('service') || text.includes('接客') || text.includes('対応')) return 'Staff';
        if ((text.includes('japanese') && text.includes('chanel')) || text.includes('japanesechannel') || text.includes('和風') || text.includes('和室')) return 'Japanese-chanel';
        if (text.includes('internet') || text.includes('wifi') || text.includes('wi-fi') || text.includes('ネット')) return 'Internet';
        if (text.includes('massage') || text.includes('マッサージ')) return 'Massage';
        if ((text.includes('japan') && text.includes('res')) || text.includes('japanres') || text.includes('restaurant') || text.includes('食事')) return 'Japan-res';
        if (text.includes('speakjp') || text.includes('speakjapanese') || text.includes('日本語') || text.includes('会話')) return 'Speak JP';
        if (text.includes('other') || text.includes('その他')) return 'Other';
        return '';
    }

    function buildStatisticFromSurveys(allSurvey) {
        const source = Array.isArray(allSurvey) ? allSurvey : [];

        const q1 = createCounter(["1 day", "2-6 days", "1-4 week", "above 1 month"]);
        const q2 = createCounter(["secret", "20's", "30's", "40's", "50's", "Above 50's"]);
        const q3 = createCounter(["First time", "Second time", "Third time", "More than"]);
        const q4 = createCounter(["Company", "Introduction", "AZ WEB", "OTA", "Google", "SNS", "POSTE", "Magazine", "Other"]);
        const q6 = createCounter(["Price", "Location", "Rotenburo", "Clealiness", "Breakfast", "Amenity", "Staff", "Japanese-chanel", "Internet", "Massage", "Japan-res", "Speak JP", "Other"]);
        const q7 = createCounter(["Come again", "Don't know", "Don't come again"]);
        const totals = { q1: 0, q2: 0, q3: 0, q4: 0, q6: 0, q7: 0 };

        const score = {
            Reception: { sum: 0, count: 0 },
            Azuman: { sum: 0, count: 0 },
            Kitchen: { sum: 0, count: 0 },
            HK: { sum: 0, count: 0 },
            Roten: { sum: 0, count: 0 },
            Massage: { sum: 0, count: 0 },
        };

        source.forEach(survey => {
            const keyQ1 = resolveHowLongStaying(survey?.question1);
            if (keyQ1) {
                increaseCounter(q1, keyQ1);
                totals.q1 += 1;
            }

            const keyQ2 = resolveGuestAge(survey?.question2);
            if (keyQ2) {
                increaseCounter(q2, keyQ2);
                totals.q2 += 1;
            }

            const keyQ3 = resolveHowManyTimes(survey?.question3);
            if (keyQ3) {
                increaseCounter(q3, keyQ3);
                totals.q3 += 1;
            }

            const keyQ4 = resolveHowKnowAz(survey?.question4);
            if (keyQ4) {
                increaseCounter(q4, keyQ4);
                totals.q4 += 1;
            }

            const keyQ7 = resolveComeAgain(survey?.question7);
            if (keyQ7) {
                increaseCounter(q7, keyQ7);
                totals.q7 += 1;
            }

            let hasQ6 = false;

            splitImportantPoints(survey?.question6).forEach(point => {
                const keyQ6 = resolveImportantPoint(point);
                if (keyQ6) {
                    increaseCounter(q6, keyQ6);
                    hasQ6 = true;
                }
            });
            if (hasQ6) totals.q6 += 1;

            const question5 = Array.isArray(survey?.question5) ? survey.question5 : [];
            const scoreReception = getScoreFromQuestion5(question5, 1);
            if (scoreReception > 0) {
                score.Reception.sum += scoreReception;
                score.Reception.count += 1;
            }

            const azumanInputs = [getScoreFromQuestion5(question5, 2), getScoreFromQuestion5(question5, 7)].filter(item => item > 0);
            if (azumanInputs.length > 0) {
                score.Azuman.sum += azumanInputs.reduce((acc, item) => acc + item, 0) / azumanInputs.length;
                score.Azuman.count += 1;
            }

            const kitchenInputs = [getScoreFromQuestion5(question5, 2), getScoreFromQuestion5(question5, 3), getScoreFromQuestion5(question5, 4), getScoreFromQuestion5(question5, 7)].filter(item => item > 0);
            if (kitchenInputs.length > 0) {
                score.Kitchen.sum += kitchenInputs.reduce((acc, item) => acc + item, 0) / kitchenInputs.length;
                score.Kitchen.count += 1;
            }

            const hkInputs = [getScoreFromQuestion5(question5, 2), getScoreFromQuestion5(question5, 6), getScoreFromQuestion5(question5, 7)].filter(item => item > 0);
            if (hkInputs.length > 0) {
                score.HK.sum += hkInputs.reduce((acc, item) => acc + item, 0) / hkInputs.length;
                score.HK.count += 1;
            }

            const scoreRoten = getScoreFromQuestion5(question5, 8);
            if (scoreRoten > 0) {
                score.Roten.sum += scoreRoten;
                score.Roten.count += 1;
            }

            const scoreMassage = getScoreFromQuestion5(question5, 9);
            if (scoreMassage > 0) {
                score.Massage.sum += scoreMassage;
                score.Massage.count += 1;
            }
        });

        const scoreAverage = {
            Reception: score.Reception.count === 0 ? 0 : Math.round((score.Reception.sum / score.Reception.count) * 100) / 100,
            Azuman: score.Azuman.count === 0 ? 0 : Math.round((score.Azuman.sum / score.Azuman.count) * 100) / 100,
            Kitchen: score.Kitchen.count === 0 ? 0 : Math.round((score.Kitchen.sum / score.Kitchen.count) * 100) / 100,
            HK: score.HK.count === 0 ? 0 : Math.round((score.HK.sum / score.HK.count) * 100) / 100,
            Roten: score.Roten.count === 0 ? 0 : Math.round((score.Roten.sum / score.Roten.count) * 100) / 100,
            Massage: score.Massage.count === 0 ? 0 : Math.round((score.Massage.sum / score.Massage.count) * 100) / 100,
        };

        return { q1, q2, q3, q4, q6, q7, scoreAverage, totals };
    }

    const areaStatistic = useMemo(() => {
        const allSurvey = Array.isArray(items?.month) ? items.month : [];
        return buildStatisticFromSurveys(allSurvey);
    }, [items]);

    const branchStatisticRows = useMemo(() => {
        return areaBranchTabs.map(item => {
            const branchSurvey = Array.isArray(item?.data?.content?.month) ? item.data.content.month : [];
            return {
                branchID: item.branchID,
                branchName: item.branchName,
                stat: buildStatisticFromSurveys(branchSurvey),
            }
        });
    }, [areaBranchTabs]);

    function renderStatisticTable(title, dataMap) {
        const labels = Object.keys(dataMap);
        return (
            <div style={{ marginTop: '12px' }}>
                <h4 style={{ marginBottom: '8px' }}>{title}</h4>
                <table id="customers" style={{ minWidth: '450px' }}>
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {labels.map(label => (
                            <tr key={`${title}_${label}`}>
                                <td style={{ fontSize: '1.2rem' }}>{label}</td>
                                <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>{dataMap[label]}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }

    function renderStatisticChart(title, dataMap, bgColor = 'rgba(53, 162, 235, 0.6)') {
        const labels = Object.keys(dataMap);
        const data = labels.map(label => Number(dataMap[label] || 0));
        return (
            <div style={{ marginTop: '12px' }}>
                <h4 style={{ marginBottom: '8px' }}>{title}</h4>
                <Bar
                    options={{
                        responsive: true,
                        plugins: {
                            legend: { display: false },
                            title: { display: false },
                        },
                        scales: {
                            y: {
                                beginAtZero: true
                            }
                        }
                    }}
                    data={{
                        labels,
                        datasets: [{
                            label: title,
                            data,
                            backgroundColor: bgColor,
                        }],
                    }}
                />
            </div>
        )
    }

    function calculateQ1Distribution(surveyList) {
        const counter = createCounter(["1 day", "2-6 days", "1-4 week", "above 1 month"]);
        let totalValid = 0;

        surveyList.forEach(survey => {
            const keyQ1 = resolveHowLongStaying(survey?.question1);
            if (keyQ1) {
                increaseCounter(counter, keyQ1);
                totalValid += 1;
            }
        });

        return { counter, totalValid };
    }

    function formatPercent(value, total) {
        if (!total) return "0%";
        return `${((Number(value || 0) * 100) / total).toFixed(2)}%`;
    }

    function renderBranchAreaPercentTable(title, labels, mapKey, totalKey) {
        if (!isAreaAllMode) return "";

        const chartPalette = [
            'rgba(255, 99, 132, 0.65)',
            'rgba(54, 162, 235, 0.65)',
            'rgba(255, 206, 86, 0.65)',
            'rgba(75, 192, 192, 0.65)',
            'rgba(153, 102, 255, 0.65)',
            'rgba(255, 159, 64, 0.65)',
        ];

        const percentFromTable = (row, label) => {
            const total = row.stat?.totals?.[totalKey] || 0;
            if (!total) return 0;
            return Math.round((Number(row.stat?.[mapKey]?.[label] || 0) * 10000) / total) / 100;
        };

        const chartData = {
            labels,
            datasets: branchStatisticRows.map((row, index) => ({
                label: row.branchName,
                data: labels.map(label => percentFromTable(row, label)),
                backgroundColor: chartPalette[index % chartPalette.length],
            })),
        };

        return (
            <div style={{ marginTop: '24px' }}>
                <h4 style={{ marginBottom: '8px', textAlign: 'left', fontWeight: '600'  }}>{title}</h4>
                <div className='d-flex' >
                    <table id="customers" style={{ width: '60%' }}>
                        <thead>
                            <tr>
                                <th>Area</th>
                                {labels.map(label => <th key={`${title}_head_${label}`}>{label}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                branchStatisticRows.map(row => (
                                    <tr key={`${title}_branch_${row.branchID}`}>
                                        <td style={{ fontSize: '1.2rem' }}>{row.branchName}</td>
                                        {labels.map(label => (
                                            <td key={`${title}_${row.branchID}_${label}`} style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                                {formatPercent(row.stat?.[mapKey]?.[label], row.stat?.totals?.[totalKey])}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            }
                            <tr style={{ background: '#fff200', fontWeight: '700' }}>
                                <td style={{ fontSize: '1.2rem' }}>{displayAreaName}</td>
                                {labels.map(label => (
                                    <td key={`${title}_area_${label}`} style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                        {formatPercent(areaStatistic?.[mapKey]?.[label], areaStatistic?.totals?.[totalKey])}
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ width: '40%', marginLeft: '20px' }}>
                        <h4 style={{ marginBottom: '8px' }}>Branch Chart (%)</h4>
                        <Bar
                            options={{
                                responsive: true,
                                plugins: {
                                    legend: { display: true, position: 'bottom' },
                                    title: { display: false },
                                },
                                scales: {
                                    y: {
                                        beginAtZero: true,
                                        max: 100,
                                        ticks: {
                                            callback: (value) => `${value}%`
                                        }
                                    }
                                }
                            }}
                            data={chartData}
                        />
                    </div>
                 </div>
            </div>
        )
    }

    function renderScoreAverageBranchAreaTable() {
        if (!isAreaAllMode) return "";
        const labels = ["Reception", "Azuman", "Kitchen", "HK", "Roten", "Massage"];
        const chartPalette = [
            'rgba(255, 99, 132, 0.65)',
            'rgba(54, 162, 235, 0.65)',
            'rgba(255, 206, 86, 0.65)',
            'rgba(75, 192, 192, 0.65)',
            'rgba(153, 102, 255, 0.65)',
            'rgba(255, 159, 64, 0.65)',
        ];

        const chartData = {
            labels,
            datasets: branchStatisticRows.map((row, index) => ({
                label: row.branchName,
                data: labels.map(label => Number(row.stat?.scoreAverage?.[label] || 0)),
                backgroundColor: chartPalette[index % chartPalette.length],
            })),
        };

        return (
            <div style={{ marginTop: '12px' }}>
                <h4 style={{ marginBottom: '8px', textAlign: 'left', fontWeight: '600'  }}>5. Score Survey</h4>
                <div className='d-flex'>
                    <table id="customers" style={{ width: '60%', }}>
                        <thead>
                            <tr>
                                <th>Area</th>
                                {labels.map(label => <th key={`score_head_${label}`}>{label}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                branchStatisticRows.map(row => (
                                    <tr key={`score_branch_${row.branchID}`}>
                                        <td style={{ fontSize: '1.2rem' }}>{row.branchName}</td>
                                        {labels.map(label => (
                                            <td key={`score_${row.branchID}_${label}`} style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                                {row.stat?.scoreAverage?.[label] || 0}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            }
                            <tr style={{ background: '#fff200', fontWeight: '700' }}>
                                <td style={{ fontSize: '1.2rem' }}>{displayAreaName}</td>
                                {labels.map(label => (
                                    <td key={`score_area_${label}`} style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                        {areaStatistic?.scoreAverage?.[label] || 0}
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ width: '40%' }}>
                        <h4 style={{ marginBottom: '8px' }}>Branch Chart</h4>
                        <Bar
                            options={{
                                responsive: true,
                                plugins: {
                                    legend: { display: true, position: 'bottom' },
                                    title: { display: false },
                                },
                                scales: { y: { beginAtZero: true } }
                            }}
                            data={chartData}
                        />
                    </div>
                </div>
            </div>
        )
    }

    const q1ByBranchAndArea = useMemo(() => {
        const branchRows = areaBranchTabs.map(item => {
            const branchSurvey = Array.isArray(item?.data?.content?.month) ? item.data.content.month : [];
            const stat = calculateQ1Distribution(branchSurvey);
            return {
                branchID: item.branchID,
                branchName: item.branchName,
                ...stat,
            }
        });

        const areaSurvey = Array.isArray(items?.month) ? items.month : [];
        const areaTotal = calculateQ1Distribution(areaSurvey);

        return { branchRows, areaTotal };
    }, [areaBranchTabs, items]);

    function renderQ1BranchAreaTable() {
        if (!isAreaAllMode) return "";

        const q1Labels = ["1 day", "2-6 days", "1-4 week", "above 1 month"];
        const chartPalette = [
            'rgba(255, 99, 132, 0.65)',
            'rgba(54, 162, 235, 0.65)',
            'rgba(255, 206, 86, 0.65)',
            'rgba(75, 192, 192, 0.65)',
            'rgba(153, 102, 255, 0.65)',
            'rgba(255, 159, 64, 0.65)',
        ];

        const toPercentValue = (value, total) => {
            if (!total) return 0;
            return Math.round((Number(value || 0) * 10000) / total) / 100;
        };

        const q1ChartData = {
            labels: q1Labels,
            datasets: q1ByBranchAndArea.branchRows.map((row, index) => ({
                label: row.branchName,
                data: q1Labels.map(label => toPercentValue(row.counter[label], row.totalValid)),
                backgroundColor: chartPalette[index % chartPalette.length],
            })),
        };

        return (
            <div style={{ marginTop: '12px' }}>
                <h4 style={{ marginBottom: '8px', textAlign: 'left' }}>1. How long guest staying</h4>
                <div className='d-flex'>
                    <table id="customers" style={{ width: '60%' }}>
                        <thead>
                            <tr>
                                <th>Area</th>
                                <th>1 day</th>
                                <th>2-6 days</th>
                                <th>1-4 week</th>
                                <th>above 1 month</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                q1ByBranchAndArea.branchRows.map(row => (
                                    <tr key={`q1_branch_${row.branchID}`}>
                                        <td style={{ fontSize: '1.2rem' }}>{row.branchName}</td>
                                        <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>{formatPercent(row.counter["1 day"], row.totalValid)}</td>
                                        <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>{formatPercent(row.counter["2-6 days"], row.totalValid)}</td>
                                        <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>{formatPercent(row.counter["1-4 week"], row.totalValid)}</td>
                                        <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>{formatPercent(row.counter["above 1 month"], row.totalValid)}</td>
                                    </tr>
                                ))
                            }

                            <tr style={{ background: '#fff200', fontWeight: '700' }}>
                                <td style={{ fontSize: '1.2rem' }}>{displayAreaName}</td>
                                <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                    {formatPercent(q1ByBranchAndArea.areaTotal.counter["1 day"], q1ByBranchAndArea.areaTotal.totalValid)}
                                </td>
                                <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                    {formatPercent(q1ByBranchAndArea.areaTotal.counter["2-6 days"], q1ByBranchAndArea.areaTotal.totalValid)}
                                </td>
                                <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                    {formatPercent(q1ByBranchAndArea.areaTotal.counter["1-4 week"], q1ByBranchAndArea.areaTotal.totalValid)}
                                </td>
                                <td style={{ fontSize: '1.2rem', textAlign: 'center' }}>
                                    {formatPercent(q1ByBranchAndArea.areaTotal.counter["above 1 month"], q1ByBranchAndArea.areaTotal.totalValid)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ width: '40%', marginLeft: '20px' }}>
                        <h4 style={{ marginBottom: '8px' }}>Branch Chart (%)</h4>
                        <Bar
                            options={{
                                responsive: true,
                                plugins: {
                                    legend: { display: true, position: 'bottom' },
                                    title: { display: false },
                                },
                                scales: {
                                    y: {
                                        beginAtZero: true,
                                        max: 100,
                                        ticks: {
                                            callback: (value) => `${value}%`
                                        }
                                    }
                                }
                            }}
                            data={q1ChartData}
                        />
                    </div>
                </div>
            </div>
        )
    }

    function renderTableScore() {
        var result = [];
        const weekOnAverageWeek = Object.keys(averageWeek);
        weekOnAverageWeek.forEach(week => {
            const weekScore = calculatorWeek?.[week] || {};
            return result.push(<tr>
                <td style={cssValue.td}>{week}</td>
                <td style={cssValue.td}>{weekScore.reception > 0 ? weekScore.reception : ""}</td>
                <td style={cssValue.td}>{weekScore.azuman > 0 ? weekScore.azuman : ""}</td>
                <td style={cssValue.td}>{weekScore.kitchen > 0 ? weekScore.kitchen : ""}</td>
                <td style={cssValue.td}>{weekScore.hk > 0 ? weekScore.hk : ""}</td>
                <td style={cssValue.td}>{weekScore.roten > 0 ? weekScore.roten : ""}</td>
                <td style={cssValue.td}>{weekScore.massage > 0 ? weekScore.massage : ""}</td>
                <td className={isNotHidden}>{weekScore.server > 0 ? weekScore.server : ""}</td>
                <td className={isNotHidden}>{weekScore.maintainer > 0 ? weekScore.maintainer : ""}</td>
                { demoVersion && <td style={cssValue.td}>{weekScore.otherRC > 0 ? weekScore.otherRC : ""}</td>}
                { demoVersion && <td style={cssValue.td}>{weekScore.otherClear > 0 ? weekScore.otherClear : ""}</td>}
            </tr>)
        });

        const monthScore = calculatorWeek?.["Month"] || {};

        result.push(<tr>
            <td style={cssValue.td}>Total</td>
            <td style={cssValue.td}>{monthScore.reception || ""}</td>
            <td style={cssValue.td}>{monthScore.azuman || ""}</td>
            <td style={cssValue.td}>{monthScore.kitchen || ""}</td>
            <td style={cssValue.td}>{monthScore.hk || ""}</td>
            <td style={cssValue.td}>{monthScore.roten || ""}</td>
            <td style={cssValue.td}>{monthScore.massage || ""}</td>
            <td className={isNotHidden}>{monthScore.server || ""}</td>
            <td className={isNotHidden}>{monthScore.maintainer || ""}</td>
            { demoVersion && <td style={cssValue.td}>{monthScore.otherRC || ""}</td>}
            { demoVersion && <td style={cssValue.td}>{monthScore.otherClear || ""}</td>}
        </tr>);
        return result
    }

    function renderCompare2MonthsTableScore() {
        var result = [];
        const monthScore = calculatorWeek?.["Month"] || {};
        const oldMonthScore = oldMonth?.calculatorWeek?.["Month"] || {};

        const DifferenceRC = Math.round(((monthScore.reception || 0) - (oldMonthScore.reception || 0)) * 100) / 100;
        const DifferenceAzuman = Math.round(((monthScore.azuman || 0) - (oldMonthScore.azuman || 0)) * 100) / 100;
        const DifferenceKitchen = Math.round(((monthScore.kitchen || 0) - (oldMonthScore.kitchen || 0)) * 100) / 100;
        const DifferenceHK = Math.round(((monthScore.hk || 0) - (oldMonthScore.hk || 0)) * 100) / 100;
        const DifferenceRoten = Math.round(((monthScore.roten || 0) - (oldMonthScore.roten || 0)) * 100) / 100;
        const DifferenceMassage = Math.round(((monthScore.massage || 0) - (oldMonthScore.massage || 0)) * 100) / 100;
        const DifferenceServer = Math.round(((monthScore.server || 0) - (oldMonthScore.server || 0)) * 100) / 100;
        const DifferenceMaintainer = Math.round(((monthScore.maintainer || 0) - (oldMonthScore.maintainer || 0)) * 100) / 100;
        const DifferenceOtherRc = Math.round(((monthScore.otherRC || 0) - (oldMonthScore.otherRC || 0)) * 100) / 100;
        const DifferenceOtherClear = Math.round(((monthScore.otherClear || 0) - (oldMonthScore.otherClear || 0)) * 100) / 100;

        result.push(<>
            <tr>
                <td style={cssValue.td}>This Month</td>
                <td style={cssValue.td}>{monthScore.reception || ""}</td>
                <td style={cssValue.td}>{monthScore.azuman || ""}</td>
                <td style={cssValue.td}>{monthScore.kitchen || ""}</td>
                <td style={cssValue.td}>{monthScore.hk || ""}</td>
                <td style={cssValue.td}>{monthScore.roten || ""}</td>
                <td style={cssValue.td}>{monthScore.massage || ""}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {monthScore.server || ""}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {monthScore.maintainer || ""}</td>
                {demoVersion && <td style={cssValue.td} className={!isNotHidden}>{monthScore.otherRC || ""}</td>}
                {demoVersion && <td style={cssValue.td} className={!isNotHidden}>{monthScore.otherClear || ""}</td>}
            </tr>
            <tr>
                <td style={cssValue.td}>Old Month</td>
                <td style={cssValue.td}>{oldMonthScore.reception || ""}</td>
                <td style={cssValue.td}>{oldMonthScore.azuman || ""}</td>
                <td style={cssValue.td}>{oldMonthScore.kitchen || ""}</td>
                <td style={cssValue.td}>{oldMonthScore.hk || ""}</td>
                <td style={cssValue.td}>{oldMonthScore.roten || ""}</td>
                <td style={cssValue.td}>{oldMonthScore.massage || ""}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {oldMonthScore.server || ""}</td>
                <td style={{ width: '70px', fontSize: '1.2rem' }} className={isNotHidden}>
                    {oldMonthScore.maintainer || ""}</td>
                {demoVersion && <td style={cssValue.td} className={!isNotHidden}>{oldMonthScore.otherRC || ""}</td>}
                {demoVersion && <td style={cssValue.td} className={!isNotHidden}>{oldMonthScore.otherClear || ""}</td>}
            </tr>
            <tr className="op-fontweight600">
                <td style={cssValue.td}>Difference</td>
                <td style={cssValue.td} className={DifferenceRC < 0 ? "op-redcolor" : ""}>{DifferenceRC}</td>
                <td style={cssValue.td} className={DifferenceAzuman < 0 ? "op-redcolor" : ""}>{DifferenceAzuman}</td>
                <td style={cssValue.td} className={DifferenceKitchen < 0 ? "op-redcolor" : ""}>{DifferenceKitchen}</td>
                <td style={cssValue.td} className={DifferenceHK < 0 ? "op-redcolor" : ""}>{DifferenceHK}</td>
                <td style={cssValue.td} className={DifferenceRoten < 0 ? "op-redcolor" : ""}>{DifferenceRoten}</td>
                <td style={cssValue.td} className={DifferenceMassage < 0 ? "op-redcolor" : ""}>{DifferenceMassage}</td>
                <td style={cssValue.td} className={(DifferenceMaintainer < 0 ? "op-redcolor" : "")
                    + (isNotHidden)}>{DifferenceServer}</td>
                <td style={cssValue.td} className={(DifferenceMaintainer < 0 ? "op-redcolor" : "")
                    + (isNotHidden)}>{DifferenceMaintainer}</td>
                {demoVersion && <td style={cssValue.td} className={DifferenceOtherRc < 0 ? "op-redcolor" : ""}>{DifferenceOtherRc}</td>}
                {demoVersion && <td style={cssValue.td} className={DifferenceOtherClear < 0 ? "op-redcolor" : ""}>{DifferenceOtherClear}</td>}
            </tr>
            <tr>
                <td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
                { demoVersion && <td style={{ width: '70px' }} className={!isNotHidden}>-</td>}
              { demoVersion && <td style={{ width: '70px' }} className={!isNotHidden}>-</td>}
            </tr>
            <tr>
                <td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
                <td style={{ width: '70px' }} className={isNotHidden}>-</td>
                { demoVersion && <td style={{ width: '70px' }} className={!isNotHidden}>-</td>}
                { demoVersion && <td style={{ width: '70px' }} className={!isNotHidden}>-</td>}
            </tr>

        </>);
        return result
    }

    function renderTableGuestOpinion() {
        var result = [];
        var count = 0;
        const listKeyOnGuestOpinion = Object.keys(guestOpinion);
        //+ " @" + opnion.mtime
        listKeyOnGuestOpinion.forEach(week => {
            if (guestOpinion[week].length > 0) {
                result.push(<tr>
                    <td className="bg_yellow" colSpan={showBranchOnFeedback ? 6 : 5}>{week.toUpperCase()}</td>
                </tr>)
                guestOpinion[week].forEach((opinion, index) => {
                    count += 1;
                    const b="\n";
                   // const countLine = opinion.question8.split(b).length - 1;
                    const countLine = Math.round(opinion.question8.length/50);
                    return result.push(
                        <tr className={(hiddenPaperSurvey && opinion.question8.toLowerCase().includes("paper survey")) ? "op-hidden" : ""}>
                            <td style={{ fontSize: '1.2rem' }}>{count}</td>
                            <td style={{ fontSize: '1.2rem' }}>{opinion.day}</td>
                            {showBranchOnFeedback ? <td style={{ fontSize: '1.2rem' }}>{opinion.branchName || "-"}</td> : ""}
                            <td style={{ fontSize: '1.2rem' }}>{opinion.roomNumber}</td>
                            <td style={{ fontSize: '1.2rem' }}><textarea style={{ width: '100%',minHeight: (30 + countLine*25) +"px" }}
                                disabled="true">
                                {opinion.question8}</textarea>
                            </td>
                            <td style={{ fontSize: '1.2rem' }}>
                                <textarea style={{ width: '100%',minHeight: (30 + countLine*25) +"px" }}
                                    onBlur={e => props.updateNoteToServer(e.target.value, opinion, week, index, "survey")}
                                    disabled={(role === 3 && checkSend) ? false : true}>
                                    {opinion.supFeedback}
                                </textarea></td>
                        </tr >)
                })
            }
        })
        return result
    }

    return (
        <React.Fragment >
            <div className="d-flex survey_online"
                style={{ with: '100%' }}>

                <div className={mode === "feedback" ? "op-hidden" : "survey_online-report mr-3 mb-5 ml-3 col"}  // mr-5 mb-5 ml-5
                    style={{ width: isAreaAllMode ? '100%' : '60%' }}
                >
                    <h1>Month Score Survey</h1>
                    <div>
                        <div className={mode === "statistic" ? "op-hidden" : "nav nav-tabs nav-fill survey_report_select mb-3"} role="tablist">
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("thisMonth")}
                                style={{ backgroundColor: 'pink', color: 'black', fontWeight: '600', cursor: "pointer", opacity: typeView === "thisMonth" ? "1" : "0.5" }}>
                                Score Table this Month</span>
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("twoMonths")}
                                style={{ backgroundColor: 'pink', color: 'black', fontWeight: '600', cursor: "pointer", opacity: typeView === "twoMonths" ? "1" : "0.5" }}>
                                Difference 2 Months</span>
                            <span className="nav-item nav-link survey_report_select-item"
                                onClick={() => setTypeView("statistic")}
                                style={{ backgroundColor: 'pink', color: 'black', fontWeight: '600', cursor: "pointer", opacity: typeView === "statistic" ? "1" : "0.5" }}>
                                Statistic</span>
                        </div>
                            <table id="customers" className={effectiveTypeView === "thisMonth" ? "" : "op-hidden"}>
                            <tr>
                                <th style={{ width: '70px' }}>Week</th>
                                <th style={{ width: '70px' }}>Reception</th>
                                <th style={{ width: '70px' }}>Azuman</th>
                                <th style={{ width: '70px' }}>Kitchen</th>
                                <th style={{ width: '70px' }}>HK</th>
                                <th style={{ width: '70px' }}>Roten</th>
                                <th style={{ width: '70px' }}>Massage</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Server</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Maintainer</th>
                                {demoVersion && <th style={{ width: '70px' }} className={!isNotHidden}>Other Attitude</th>}
                                {demoVersion && <th style={{ width: '70px' }} className={!isNotHidden}>Other Cleanliness</th>}
                            </tr>
                            {renderTableScore()}
                        </table>
                        <table id="customers" className={effectiveTypeView === "twoMonths" ? "" : "op-hidden"}>
                            <tr>
                                <th style={{ width: '70px' }}>Week</th>
                                <th style={{ width: '70px' }}>Reception</th>
                                <th style={{ width: '70px' }}>Azuman</th>
                                <th style={{ width: '70px' }}>Kitchen</th>
                                <th style={{ width: '70px' }}>HK</th>
                                <th style={{ width: '70px' }}>Roten</th>
                                <th style={{ width: '70px' }}>Massage</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Server</th>
                                <th style={{ width: '70px' }} className={isNotHidden}>
                                    Maintainer</th>
                                {demoVersion && <th style={{ width: '70px' }} className={!isNotHidden}>Other Attitude</th>}
                                {demoVersion && <th style={{ width: '70px' }} className={!isNotHidden}>Other Cleanliness</th>}
                            </tr>
                            {renderCompare2MonthsTableScore()}
                        </table>
                            <div className={effectiveTypeView === "statistic" && !isAreaAllMode ? "d-flex" : "op-hidden"}
                             style={{fontSize:'1.5rem'}}
                        >
                            <div>
                                <div style={{fontWeight:'600'}}>Type Survey</div>
                                <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Application</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.app}</div>
                                </div>
                                <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Room Scan</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.room}</div>
                                </div>
                                <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Public Input</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.public1}</div>
                                </div>
                                <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Public Scan</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.public2}</div>
                                </div>
                                 <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Mail</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.mail}</div>
                                </div>
                                 <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Membership</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.membership}</div>
                                </div>
                            </div>
                            <div className='ml-2'>
                               <div style={{fontWeight:'600'}}>Bad Point/Don't Come</div>
                               <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Bab point</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.badPoint}</div>
                                </div>
                                <div className='d-flex'>
                                    <div style={{width:'200px', background:'#04aa6d',fontWeight:'600',color: 'white',border:'1px solid black'}}>Guest not come back</div>
                                    <div style={{border:'0.7px solid', padding:'0 12px', width:'40px'}}>{sumTypeSurvey.notCome}</div>
                                </div>
                            </div>
                        </div>

                        <div className={effectiveTypeView === "statistic" && isAreaAllMode ? "" : "op-hidden"} style={{ marginTop: '18px' }}>
                            {/* <h2>Survey Statistic (Area - All)</h2>
                            <h4>Question 1 ~ Question 7 (Question 8 is excluded)</h4> */}
                            {renderQ1BranchAreaTable()}
                            {renderBranchAreaPercentTable("2. Guest Age", ["secret", "20's", "30's", "40's", "50's", "Above 50's"], "q2", "q2")}
                            {renderBranchAreaPercentTable("3. How Many Times", ["First time", "Second time", "Third time", "More than"], "q3", "q3")}
                            {renderBranchAreaPercentTable("4. How to Know Az", ["Company", "Introduction", "AZ WEB", "OTA", "Google", "SNS", "POSTE", "Magazine", "Other"], "q4", "q4")}
                            {renderScoreAverageBranchAreaTable()}
                            {renderBranchAreaPercentTable("6. Important Points", ["Price", "Location", "Rotenburo", "Clealiness", "Breakfast", "Amenity", "Staff", "Jap-chanel", "Internet", "Massage", "Japan-res", "Speak JP", "Other"], "q6", "q6")}
                            {renderBranchAreaPercentTable("7. Come Again", ["Come again", "Don't know", "Don't come again"], "q7", "q7")}
                        </div>
                    </div>
                    
                    {!isAreaAllMode && <h1 className='mt-5'>Survey Chart Month</h1>}
                    {!isAreaAllMode && <Bar options={options} data={dataChart} />}
                    {/* </div> */}
                </div>

                <div className={mode === "feedback" || ((mode === "statistic" || mode === "report") && !isAreaAllMode) ? "col mr-3 survey_online-feedback" : "op-hidden"}
                    style={{ borderLeft: mode === "feedback" ? '0' : '1px solid #333', maxHeight: '800px', overflowX: 'scroll', width: mode === "feedback" ? '100%' : '40%' }}>
                    <h1>Guest Feedback</h1>
                    <h4>* Supervisor can note on [Supervisor Reply], automatic update on server and show on report mail*</h4>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '12px' }}>
                        <h4 for="vehicle3" style={{ color: 'rgb(72, 41, 121)' }}>( Hidden Paper Survey</h4>
                        <input className="ml-2" type="checkbox" name="vehicle3" value="Boat" onChange={() => setHiddenPaperSurvey(!hiddenPaperSurvey)} />
                        <h4 for="vehicle3" style={{ color: 'rgb(72, 41, 121)' }}>)</h4>
                    </div>
                    <table id="customers" className="ml-3">
                        <tr >
                            <th style={{ width: "70px", fontSize: '1.2rem' }}>NO.</th>
                            <th style={{ width: "100px", fontSize: '1.2rem' }}>Time</th>
                            {showBranchOnFeedback ? <th style={{ width: "150px", fontSize: '1.2rem' }}>Branch</th> : ""}
                            <th style={{ width: "70px", fontSize: '1.2rem' }}>Room</th>
                            <th style={{ width: "400px", fontSize: '1.2rem' }}>Feedback / Opinion</th>
                            <th style={{ width: "250px", fontSize: '1.2rem' }}>Supervisor Reply</th>
                        </tr>
                        {renderTableGuestOpinion()}
                    </table>
                </div>

            </div>
        </React.Fragment >
    )
}
export default NewSurveyOnlineReport
